<template>
  <div class="tabCard">
        <div class="tab-dec">
          <el-tabs tab-position="right" style="height: 100%;" class="el-tabs">
            <el-tab-pane
              v-for="(adv, idx) in items||nameList"
              :key="adv.id"
              :label="adv.name"
              class="el-tab-item"
              @click.native="clickFn(idx)"
            >
             <span slot="label">{{adv.name}}
               <div class="spans">{{adv.dec}}</div></span>
                <div class="pos">
                  <img :src="adv.path" alt="advimg" />
                </div>
            </el-tab-pane>
          </el-tabs>
        </div>
    </div>

</template>
<script>
export default {
  name: "tabCard",
  data() {
    return {
      title: "核心技术",
      titleText: "CORE TECHNOLOGY",
      tabPosition: "left",
      techAdvances: [
        {
          name: "用户管理",
          path:'',
          id: 1
        },

      ],
      nameList: [
        {
          name: "用户管理",
          path: '',
          id: 1
        },
        {
          name: "配置管理",
          path: '',
          id: 2
        },
        {
          name: "角色管理",
          path: '',
          id: 3
        }
      ]
    };
  },
  props:['items'],
  components: {

  },
  methods: {
    clickFn(ind) {
      console.log(ind);
    }
  }
};
</script>
<style lang="less" scoped>
.tabCard {
  width: 100%;
  height: 100%;
      .tab-dec {
		width: 100%;
		height: 100%;
		// 控制文字不换行
		/deep/ .el-tabs__nav {
		                 white-space: pre-wrap;
						 width: 200px;
		               }
		// flex
		/deep/  .el-tabs {
		    overflow: hidden;
		    height: 100%;
		    width: 100%;
		    display: flex;
		    flex-direction: row-reverse;
			}
			 // 展出的内容
		/deep/ .el-tabs__item.is-active {
		  height: 100%;
		   font-family: PingFangSC-Regular, PingFang SC;
		    font-weight: 400;
		    color: #FFFFFF;
		     font-size: 14px;
		    padding: 0 0 10px 20px;
		  .spans{
		    display: block;
		    width: 168px;
		    margin-top: -30px;
			line-height: 22px;
		    font-size: 12px;
		    letter-spacing: 3px;
		    // background-color: #000000;
		  }
		}
		.pos {
		  width: 100%;
		  height: 100%;//图片
		  img {
		    width: 100%;
		    height: 100%;
		  }
		}
        /deep/ .el-tabs__item.is-active {
          width: 100%;
          height: 100%;
          background: linear-gradient(
            138deg,
            #ee0090 0%,
            #e84142 100%,
            #e84142 100%
          );
          opacity: 0.8;
        }
        /deep/ .is-right::after {
          height: 0;
        }
        /deep/ .el-tabs__active-bar {
          width: 11px;
          height: 40px;
          background: linear-gradient(
            138deg,
            #ee0090 0%,
            #e84142 100%,
            #e84142 100%
          );
          opacity: 0.8;
        }
        /deep/ .el-tabs__item {
          margin-bottom: 5px;
          background: linear-gradient(
            90deg,
            #ee0090 0%,
            rgba(232, 65, 66, 0) 100%,
            #e84142 100%
          );
          background: #999999;
          margin: 2px 5px 0 0;
		  overflow: hidden;
        }

      }
    }
</style>
